import axios from 'axios';
import Swal from 'sweetalert2';

const api = axios.create({
    baseURL: '/api',
});

// Helper function to handle Swal alerts
const showAlert = (title, text, icon) => {
    Swal.fire({
        icon,
        title,
        text,
        allowEscapeKey: false,
        allowOutsideClick: false,
        allowEnterKey: false,
        confirmButtonText: 'Ok',
    }).then((result) => {
        if (result.isConfirmed) {
            location.reload();
        }
    });
};

api.interceptors.response.use(
    response => response,
    error => {
        const { status } = error.response;
        if (status === 401 || status === 403) {
            showAlert('Session Expired!', 'Please re-login', 'warning');
        } else if (status === 422) {
            return Promise.reject(error);
        } else {
            showAlert('Transaction Failed', 'Please retry again', 'warning');
        }
        return Promise.reject(error);
    }
);

// Helper function to make API calls
const apiGet = async (endpoint, params = {}) => {
    try {
        const response = await api.get(endpoint, { params });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Reference API functions
export const apiRefProvince = (code = null) => apiGet('/ref-province', { region_code: code });
export const apiRefCity = (code = null) => apiGet('/ref-city', { province_code: code });
export const apiRefBrgy = (code = null) => apiGet('/ref-brgy', { city_code: code });
export const apiRefOwnership = () => apiGet('/ref-ownership');
export const apiRefGovID= () => apiGet('/ref-gov-id');